import React from 'react'
import { Menu, Sidebar } from 'semantic-ui-react'
import { useSelector } from 'react-redux'
import styles from './sidebar.module.css'
import Logo from '../logo/logo'
import { MENU_ITEMS } from '../../dummies/menuItems'
import { MENU_ITEMS_TANK } from '../tank/dummies/menuItems'
import MenuItem from './menu-item'
import ToggleButton from '../toggle-button/toggle-button'

const CustomSidebar = () => {
  const productName = localStorage.getItem('product')
  const toggle = useSelector((store) => store.navbar.toggleMenu)
  const { userRole } = useSelector((store) => ({
    userRole: store.auth.userRole,
  }))
  // const [menus, setMenus] = useState(MENU_ITEMS)
  return (
    <Sidebar
      as={Menu}
      animation="overlay"
      icon="labeled"
      inverted
      vertical
      visible={toggle}
      width="wide"
      className={styles.container}
    >
      <Menu.Header className={styles.header}>
        <ToggleButton />
        <Logo />
      </Menu.Header>
      {productName === 'tank'
        ? MENU_ITEMS_TANK.map((item) => {
            const roles = item.role.split(',')
            if (roles.includes(userRole)) {
              return <MenuItem key={item.name} name={item.name} to={item.to} />
            }
            return null
          })
        : MENU_ITEMS.map((item) => {
            const roles = item.role.split(',')
            if (roles.includes(userRole)) {
              return <MenuItem key={item.name} name={item.name} to={item.to} />
            }
            return null
          })}
    </Sidebar>
  )
}

export default CustomSidebar
